import { useHandleUploadCancel } from './useHandleUploadCancel';
import { RegistrationRequest, UploadData, useUploadStore } from '../../../../../../../store/uploadStore';
import { getProgressUiElements } from './getProgressUiElements';
import { CalculatedUploadState, useCalculatedUploadState } from '../../../../tabs/card/useCalculatedUploadState';
import { UploadProgress } from '../UploadProgress';
import { ProjectData } from '../../../../types';
import { ScheduledFlight } from '../../../../../../../types';
import { getUploadProgress } from '../../../../helpers/uploadProgress';

interface Props extends ProjectData {
  isPano: boolean;
  schedule?: ScheduledFlight;
  registrationRequests: Map<Promise<unknown>, RegistrationRequest> | undefined;
  upload: UploadData | undefined;
}

export const FlightUploadProgress = ({ isPano, customer, site, schedule, registrationRequests, upload }: Props) => {
  const uploadState = useCalculatedUploadState(isPano, customer.id, site.id, schedule?.airtableRecordId);
  const handleCancel = useHandleUploadCancel(isPano, customer, site, schedule, false);
  const { bytesPerSecond, fileRegistrationTimeMs } = useUploadStore();

  if (!registrationRequests?.size && !upload?.overview) {
    return;
  }

  const { isWarning, icon, title, note, removeIcon, disableCancel, tooltip } = getProgressUiElements(
    uploadState,
    registrationRequests,
    upload,
    bytesPerSecond,
    fileRegistrationTimeMs,
  );

  const progress = getUploadProgress(upload);

  return (
    <UploadProgress
      icon={icon}
      title={title}
      note={note}
      removeIcon={removeIcon}
      isWarning={isWarning}
      onRemoveClick={handleCancel}
      disableCancel={disableCancel}
      progress={progress}
      isDone={uploadState === CalculatedUploadState.Completed}
      tooltip={tooltip}
    />
  );
};
